export const SET_CENTROS_CUSTOS = 'centrosCustos';
export const SET_SOLICITANTES = 'solicitantes';
export const SET_PRODUTO = 'produto';
export const SET_PROJETO = 'projeto';
export const SET_SEARCH_TEXT = 'searchText';
export const SET_EMPRESA = 'empresa';
export const SET_LOCAL_ENTREGA = 'localEntrega';
export const SET_GRUPO = 'grupo';
export const SET_DATA_INICIAL = 'dataInicial';
export const SET_DATA_FINAL = 'dataFinal';
export const SET_DATA_ENTREGA_INICIAL = 'dataEntregaInicial';
export const SET_DATA_ENTREGA_FINAL = 'dataEntregaFinal';
export const SET_URGENCIA = 'urgencia';
export const SET_SHOW_ESPECIFICACAO = 'showEspecificacao';
export const SET_SHOW_OBSERVACAO_EXTERNA = 'showObservacaoExterna';
export const SET_SHOW_OBSERVACAO_INTERNA = 'showObservacaoInterna';
export const SET_COMPRADORES = 'compradores';
export const SET_CURRENT_PAGE = 'page';
export const SET_OFFSET = 'offset';
export const SET_FILTER = 'filter';
export const SET_LIST_OPTIONS = 'listOptions';
export const SET_CURRENT_SESSION_STATE = 'sessionState';
export const INIT_STATE = 'initState';
